import React from "react";
import { Line } from "react-chartjs-2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { lineOptions } from "./_commonSharedChartOptions";
import {
  WidgetLoading,
  WidgetNoDataToDisplay,
  WidgetServerError
} from "../../../../components/DashboardWidget/WidgetCommon";
import { peakUsageTimeDataPreview } from "./_previewData";
import _ from "lodash";

const widgetDetails = {
  Chart: "PEAK_USAGE_TIME_WINDOW_BY_SKILL_BY_HOUR",
  startDate: "04/11/2019%2012:00%20AM",
  endDate: "04/24/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class PeakUsageTimeContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Peak Usage</div>
        <div className="widgetTitleDescription">Number of requests per hour</div>
        <div className="widgetBody">
          {widgetData /*&& !this.state.loading*/ ? (
            widgetData.code !== 200 || draggable ? (
              <WidgetServerError draggable={draggable} />
            ) : widgetData.chart_data.data_dict.Items.length === 0 || draggable ? (
              <WidgetNoDataToDisplay draggable={draggable} />
            ) : (
              <Line
                id={widgetDetails.Chart}
                data={{
                  labels: widgetData.chart_data.labels,
                  datasets: widgetData.chart_data.data_dict.Items
                }}
                options={_.merge({}, lineOptions, {
                  tooltips: {
                    callbacks: {
                      title: function(tooltipItem, data) {
                        return tooltipItem[0].xLabel + "h";
                      },
                      label: function(tooltipItem, data) {
                        return tooltipItem.yLabel + " requests";
                      }
                    }
                  }
                })}
              />
            )
          ) : (
            <WidgetLoading />
          )}
        </div>
      </div>
    );
  }
}

export class PeakUsageTimePreview extends React.Component {
  render() {
    return (
      <div>
        <div className="widgetTitle">Peak Usage</div>
        <div className="widgetBody">
          <Line
            data={peakUsageTimeDataPreview}
            options={_.merge({}, lineOptions, {
              maintainAspectRatio: false,
              legend: { display: false },
              plugins: {
                datalabels: {
                  font: {
                    size: 7
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard[widgetDetails.Chart],
    dashboardDates: state.dashboard.widgetFromToDate,
    skill: state.skill
  };
}

export const PeakUsageTimeContent = connect(
  mapStateToProps,
  undefined
)(PeakUsageTimeContentClass);
